export default {
  首页: "Hjem",
  资产: "Aktiver",
  币币: "Spot",
  快捷买币: "Hurtig køb af krypto",
  "支持多种方式购买，购买更简单": "Køb nemt med flere betalingsmetoder",
  语言设置: "Sprogindstillinger",
  确认恢复: "Bekræft gendannelse",
  "输入邮箱，方便我们联系您":
    "Indtast din e-mailadresse, så vi kan kontakte dig",
  划转: "Overfør",
  行情: "Marked",
  "24H成交": "24h volumen",
  累计收益: "Samlet afkast",
  充值时间: "Indbetalingsdato",
  到期时间: "Udløbsdato",
  数量: "Antal",
  操作: "Handling",
  资产信息: "Aktivinformation",
  复制地址: "Kopier adresse",
  链名称: "Kædenavn",
  充值地址: "Indbetalingsadresse",
  收款地址: "Modtageradresse",
  账单: "Faktura",
  提现金额: "Udbetalingsbeløb",
  接收地址: "Modtageradresse",
  交易密码: "Handelsadgangskode",
  提现全部: "Udbetal alt",
  保存图片: "Gem billede",
  输入您的交易密码: "Indtast din handelsadgangskode",
  确定: "Bekræft",
  地址: "Adresse",
  注册时间: "Registreringsdato",
  取消: "Annuller",
  是否划转: "Overfør?",
  登录: "Log ind",
  我的地址: "Mine adresser",
  登录密码和交易密码: "Login-adgangskode og handelsadgangskode",
  注册: "Registrer",
  密码: "Adgangskode",
  设置密码: "Indstil adgangskode",
  重复密码: "Gentag adgangskode",
  新密码: "Ny adgangskode",
  确认新密码: "Bekræft ny adgangskode",
  充值: "Indbetal",
  充值货币: "Indbetal valuta",
  合约账户充值: "Indbetal på futureskonto",
  账户充值: "Indbetal på konto",
  其他: "Andet",
  我的邀请码: "Min invitationskode",
  提现: "Udbetal",
  客服: "Kundeservice",
  持有详情: "Beholdningsdetaljer",
  请输入内容: "Indtast indhold",
  邀请好友来领取奖励: "Inviter venner og modtag belønninger",
  复制链接: "Kopier link",
  重复设置新的密码: "Gentag ny adgangskode",
  保存: "Gem",
  我的: "Min konto",
  "邮箱/手机号": "E-mail/Mobilnummer",
  备注: "Bemærkning",
  地址管理: "Adresseadministration",
  我的团队: "Mit team",
  联系我们: "Kontakt os",
  竭诚为您服务: "Vi står til din rådighed",
  提取收益: "Træk afkast ud",
  带给我的收益: "Genereret afkast",
  添加: "Tilføj",
  名称: "Navn",
  添加地址: "Tilføj adresse",
  修改地址: "Rediger adresse",
  可提现: "Udbetales kan",
  安全中心: "Sikkerhedscenter",
  收益划转: "Overfør afkast",
  通知中心: "Notifikationer",
  "累计收益:": "Samlet afkast:",
  注册用户: "Registrerede brugere",
  奖励规则: "Belønningsregler",
  帮助反馈: "Hjælp og feedback",
  邀请好友: "Inviter venner",
  恢复身份: "Gendan identitet",
  选择语言: "Vælg sprog",
  设置新的密码: "Indstil ny adgangskode",
  暂无活动: "Ingen aktive aktiviteter",
  "月增长量(+)": "Månedlig vækst (+)",
  可提取: "Kan udtrækkes",
  反馈类型: "Feedbacktype",
  赠送: "Gave",
  已经复制: "Kopieret",
  保存成功: "Gemt",
  划转成功: "Overførsel lykkedes",
  过期: "Udløbet",
  提交成功: "Indsendt",
  "服务器繁忙，稍后在试": "Serveren er optaget, prøv igen senere",
  全部: "Alle",
  一级: "Niveau 1",
  二级: "Niveau 2",
  三级: "Niveau 3",
  级: "Niveau",
  删除成功: "Slettet",
  选择地址: "Vælg adresse",
  不再提醒: "Vis ikke igen",
  "最小充值金额：": "Mindste indbetalingsbeløb:",
  选择币种: "Vælg kryptovaluta",
  输入投资金额: "Indtast investeringsbeløb",
  输入账户密码: "Indtast kontoadgangskode",
  投资: "Invester",
  订单编号: "Ordrenummer",
  投资周期: "Investeringsperiode",
  投资资金: "Investeret beløb",
  投资时间: "Investeringstidspunkt",
  状态: "Status",
  投资中: "Aktiv",
  已到期: "Udløbet",
  暂无数据: "Ingen data",
  转入: "Overfør til",
  邮箱: "E-mail",
  请输入邮箱: "Indtast e-mailadresse",
  请输入格式正确的邮箱: "Indtast en gyldig e-mailadresse",
  请输入验证码: "Indtast bekræftelseskode",
  获取验证码: "Hent bekræftelseskode",
  请输入邀请码: "Indtast invitationskode",
  今天: "I dag",
  昨天: "I går",
  最近七天: "Seneste 7 dage",
  邀请: "Inviter",
  购买数量: "Købsmængde",
  产品详情: "Produktdetaljer",
  币种: "Kryptovaluta",
  利息币种: "Afkastvaluta",
  理财类型: "Type finansprodukt",
  产品费率: "Produktgebyrer",
  进行中: "Aktiv",
  每天: "Dagligt",
  请输入搜索关键词: "Indtast søgeord",
  通知: "Notifikationer",
  查看更多: "Se mere",
  理财宝: "Finansprodukter",
  周期: "Løbetid",
  年利率: "Årlig rente (APY)",
  更多产品: "Flere produkter",
  灵活存取: "Fleksibel opsparing",
  稳定收益: "Stabilt afkast",
  合约指南: "Futures-guide",
  资金划转出: "Udgående overførsel",
  矿池收益: "Minebelønning",
  提现手续费: "Udbetalingsgebyr",
  冻结资金: "Frosne midler",
  解冻资金: "Frigør frosne midler",
  闪兑支出: "Udgift til hurtig veksling",
  闪兑收入: "Indtægt fra hurtig veksling",
  闪兑手续费: "Gebyr for hurtig veksling",
  合约支出: "Futures-udgift",
  合约收入: "Futures-indtægt",
  输入的金额不可大于可用金额: "Beløbet må ikke overstige tilgængeligt beløb",
  全部兑换成功: "Fuldstændig veksling lykkedes",
  返回: "Tilbage",
  查看历史: "Se historik",
  闪兑历史: "Historik for hurtig veksling",
  支付: "Betal",
  获取: "Få",
  时间: "Tid",
  手续费: "Transaktionsgebyr",
  折扣: "Rabat",
  价格: "Pris",
  逐仓: "Isoleret margin",
  全仓: "Krydsmargin",
  市价委托: "Markedsordre",
  限价委托: "Limitordre",
  请输入本金: "Indtast hovedstol",
  请输入价格: "Indtast pris",
  "可做空/做多": "Muligt at shorte/longe",
  设置止盈止损: "Indstil take-profit/stop-loss",
  止盈价: "Take-profit pris",
  止损价: "Stop-loss pris",
  成本: "Kostpris",
  做多: "Long",
  做空: "Short",
  仓位信息: "Positionsinformation",
  一键平仓: "Luk position (ét klik)",
  永续: "Perpetual",
  浮动盈亏: "Urealiseret gevinst/tab",
  平仓: "Luk position",
  反向开仓: "Åbn omvendt position",
  一键撤销: "Annuller alle (ét klik)",
  倍杠杆: "x gearing",
  执行价格: "Udførelsespris",
  委托数量: "Ordremængde",
  保证金: "Margin",
  成交价: "Udførelsespris",
  创建时间: "Oprettelsestid",
  撤销: "Annuller",
  合约市场: "Futures-marked",
  交易方向: "Handelsretning",
  委托价格: "Ordrepris",
  委托金额: "Ordrebeløb",
  资金费率: "Finansieringsrente",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Periodisk gebyr betalt af lange og korte positioner, afregnes hver 8. time.",
  "资金费率为正，多方向空方支付资金费用。":
    "Ved positiv finansieringsrente betaler lange positioner til korte positioner.",
  "资金费率为负，空方向多方支付资金费用。":
    "Ved negativ finansieringsrente betaler korte positioner til lange positioner.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Er du sikker på, at du vil åbne en omvendt position? Dette vil købe den modsatte retning af din nuværende position.",
  "仓位止盈/止损": "Take-profit/Stop-loss for position",
  合约名称: "Futures-kontrakt",
  开仓价格: "Åbningspris",
  指数价格: "Indekspris",
  止盈设置: "Take-profit-indstillinger",
  请输入止盈价: "Indtast take-profit-pris",
  "当指数价格触达*时，将会触发委托平仓":
    "Når indeksprisen når *, vil en lukningsordre blive udløst.",
  预计盈亏: "Forventet gevinst/tab",
  当前仓位: "Nuværende position",
  平仓金额: "Lukningsbeløb",
  仓位模式: "Positionstilstand",
  全仓模式: "Krydsmargin-tilstand",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "I krydsmargin-tilstand bruges alle tilgængelige midler på din futureskonto som margin. Likvidation sker, når tabet overstiger din samlede saldo, hvilket resulterer i tab af hele din margin og position.",
  逐仓模式: "Isoleret margin-tilstand",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "En specifik mængde margin tildeles en position. Hvis margintabet falder under vedligeholdelsesmarginniveauet, likvideres positionen. Du kan øge eller mindske marginen for denne position.",
  "是否撤销？": "Annuller ordre?",
  "是否一键撤销？": "Annuller alle ordrer?",
  "是否一键平仓？": "Luk alle positioner?",
  持仓保证金: "Margin for nuværende position",
  风险率: "Risikoprocent",
  未实现盈亏: "Urealiseret gevinst/tab",
  可用保证金: "Tilgængelig margin",
  净值: "Netto værdi",
  账户余额: "Kontosaldo",
  合约计算器: "Futures-beregner",
  交易记录: "Transaktionshistorik",
  "*倍杠杆": "*x gearing",
  "平仓盈亏：": "Lukket gevinst/tab:",
  时间筛选: "Tidsfilter",
  仓位类型: "Positionstype",
  订单状态: "Ordrestatus",
  订单类型: "Ordretype",
  平仓价格: "Lukningspris",
  持仓数量: "Positionsmængde",
  "手续费(%)": "Transaktionsgebyr (%)",
  平仓时间: "Lukningstid",
  平仓类型: "Lukningstype",
  手动平仓: "Manuel lukning",
  强制平仓: "Tvungen likvidation",
  近1天: "Seneste dag",
  近7天: "Seneste 7 dage",
  近30天: "Seneste 30 dage",
  近180天: "Seneste 180 dage",
  持仓: "Åben position",
  已取消: "Annulleret",
  分时: "Intradag",
  "24H额(USDT)": "24h volumen (USDT)",
  "24H低": "24h lav",
  "24H量(BTC)": "24h volumen (BTC)",
  "24H高": "24h høj",
  "10秒": "10 sekunder",
  "30秒": "30 sekunder",
  "1分": "1 minut",
  "3分": "3 minutter",
  "5分": "5 minutter",
  "30分": "30 minutter",
  "1小时": "1 time",
  "4小时": "4 timer",
  "8小时": "8 timer",
  "1天": "1 dag",
  "1周": "1 uge",
  "1月": "1 måned",
  单向持仓: "Ensrettet position",
  杠杆: "Gearing",
  仓位: "Position",
  计算结果: "Resultat",
  盈亏: "Gevinst/Tab",
  收益率: "Afkast",
  计算结果仅供参考: "Resultatet er vejledende",
  成交后仓位大小: "Positionens størrelse efter udførelse",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Resultatet er vejledende, faktiske resultater kan variere på grund af gebyrer.",
  目标价格: "Målpris",
  开始计算: "Beregn",
  强平价格: "Likvidationspris",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Kontroller kædenavnet omhyggeligt før indbetaling. Forkerte indbetalinger kan ikke fortrydes. Mindste indbetalingsbeløb er *. Indbetalinger under dette beløb vil ikke blive behandlet. Send ikke andre aktiver til denne adresse. Brug ikke ICO- eller crowdfunding-adresser til udbetalinger.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Mindste udbetalingsmængde er *. Udbetalingsgebyrer vil blive trukket fra udbetalingsbeløbet. Kontroller modtageradressen omhyggeligt. Send ikke * til adresser uden for *. Brug ikke ICO- eller crowdfunding-adresser.",
  退出登录: "Log ud",
  加仓: "Øg position",
  新增仓位: "Ny position",
  输入加仓金额: "Indtast beløb for at øge positionen",
  "当前可用:": "Nuværende tilgængeligt:",
  资产账单: "Aktivfaktura",
  保存二维码: "Gem QR-kode",
  温馨提示: "Bemærk",
  "请注意：您当前使用的网络": "Bemærk: Du bruger i øjeblikket netværket",
  输入提现地址: "Indtast udbetalingsadresse",
  "可用金额：": "Tilgængeligt beløb:",
  输入资产密码: "Indtast aktivadgangskode",
  可用手续费: "Tilgængeligt gebyr",
  "折扣%": "Rabat %",
  实扣手续费: "Faktisk opkrævet gebyr",
  实际到账: "Faktisk modtaget beløb",
  未设置资产密码: "Aktivadgangskode ikke indstillet",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "For din sikkerhed, indstil en aktivadgangskode, før du foretager udbetalinger.",
  热榜: "Populært",
  涨幅榜: "Største stigninger",
  跌幅榜: "Største fald",
  成交额榜: "Volumenrangering",
  关于我们: "Om os",
  登录密码: "Login-adgangskode",
  设置: "Indstillinger",
  资产密码: "Aktivadgangskode",
  修改登录密码: "Skift login-adgangskode",
  原密码: "Gammel adgangskode",
  请输入新密码: "Indtast ny adgangskode",
  请输入原密码: "Indtast gammel adgangskode",
  确认密码: "Bekræft adgangskode",
  确定修改: "Bekræft ændring",
  修改资产密码: "Skift aktivadgangskode",
  验证码: "Bekræftelseskode",
  资产密码使用提示: "Tips til aktivadgangskode",
  "资产密码用于转移、提取资产和交易。":
    "Aktivadgangskode bruges til at overføre, udbetale og handle aktiver.",
  "创建与登录密码不同的资产密码。":
    "Opret en aktivadgangskode, der er forskellig fra login-adgangskoden.",
  "定期更改您的资产密码。": "Skift din aktivadgangskode regelmæssigt.",
  提币历史: "Udbetalingshistorik",
  "金额/余额": "Beløb/Saldo",
  "手续费/折扣": "Gebyr/Rabat",
  自选: "Favoritter",
  现货: "Spot",
  市价: "Markedspris",
  止损设置: "Stop-loss-indstillinger",
  合约K线图: "Futures-diagram",
  "24H量": "24h volumen",
  "24H额": "24h volumen (USDT)",
  合作指南: "Partnerguide",
  盈亏计算: "Beregning af gevinst/tab",
  当前可用: "Nuværende tilgængeligt",
  请输入加仓金额: "Indtast beløb for at øge positionen",
  请重新输入加仓金额: "Indtast beløbet for at øge positionen igen",
  平仓数量: "Antal at lukke",
  欢迎登录: "Velkommen tilbage",
  "忘记密码?": "Glemt adgangskode?",
  "还没有账号？": "Har du ikke en konto?",
  立即注册: "Registrer dig nu",
  繁體中文: "Traditionelt kinesisk",
  找回密码: "Gendan adgangskode",
  下一步: "Næste",
  注册账户: "Registrer konto",
  "请输入邀请码(选填)": "Indtast invitationskode (valgfrit)",
  谢邀豪礼: "Invitationsbonus",
  "24小时邀请好友排名": "24-timers invitationsrangering",
  "*人": "* personer",
  "差*人": "Mangler * personer",
  "已超过10万人，每月轻松赚钱":
    "Over 100.000 brugere, tjen penge nemt hver måned",
  最高: "Maks",
  邀请链接: "Invitationslink",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Del i transaktionsgebyrerne genereret af dine venner (spot, futures, margin, hurtig veksling).",
  平台和您一起分享手续费: "Del transaktionsgebyrerne med platformen",
  "*级": "* niveau",
  规则: "Regler",
  我的好友: "Mine venner",
  好友详情: "Vendetaljer",
  获得好友佣金方案: "Venprovisionsplan",
  我的等级: "Mit niveau",
  我的邀请数据: "Mine invitationsstatistikker",
  当前等级: "Nuværende niveau",
  平台奖励您: "Platformsbelønning til dig",
  最高可获取平台奖励: "Maksimal platformsbelønning",
  邀请规则: "Invitationsregler",
  "邀请*级有效好友": "Inviter aktive venner på niveau *",
  好友等级: "Venniveau",
  人: "personer",
  奖金派送: "Bonusudbetaling",
  平台奖励: "Platformsbelønning",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Platformen har ret til endelig fortolkning. Ved svigagtige aktiviteter vil belønninger blive trukket tilbage, og din konto vil blive frosset. Tabte aktiver kan ikke gendannes.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Din konto skal være aktiv, defineret som en indbetaling på mindst * USDT i værdi i enhver kryptovaluta.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Din inviterede ven skal være en aktiv nedlinje, defineret som en indbetaling på mindst * USDT i værdi.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Invitatør og inviteret må ikke dele samme IP-adresse.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP-niveau bestemmes af antallet af inviterede venner på niveau *.",
  佣金成分: "Provisionskomponenter",
  收益统计: "Afkaststatistik",
  昨日收益: "Gårsdagens afkast",
  月收益: "Månedligt afkast",
  获取收益: "Få afkast",
  "总收益：": "Samlet afkast:",
  "*级好友": "Venner på niveau *",
  理财购买: "Køb finansprodukt",
  期限: "Løbetid",
  可用金额: "Tilgængeligt beløb",
  预估收益: "Estimeret afkast",
  申购上限: "Maksimalt køb",
  项目剩余: "Resterende projekt",
  "买入后预计*(SGT)开始计算收益。":
    "Afkast forventes at begynde at løbe cirka *(SGT) efter køb.",
  计息日: "Rentestartdato",
  申购日: "Købsdato",
  到账日: "Krediteringsdato",
  到期自动续投: "Automatisk geninvestering ved udløb",
  申购: "Køb",
  搜索理财项目: "Søg efter finansprodukt",
  超高年化随心选: "Vælg blandt produkter med højt afkast",
  "自由选择理财币种，稳定超额收益":
    "Vælg frit din kryptovaluta for stabilt, over gennemsnittet afkast",
  理财总资产: "Samlede investerede aktiver",
  申购数量: "Mængde at købe",
  立即购买: "Køb nu",
  年化收益率: "Årlig procentuel afkast (APY)",
  理财订单: "Finansproduktordrer",
  持有: "I besiddelse",
  申购份额: "Købt andel",
  到账日期: "Krediteringsdato",
  申购成功: "Køb lykkedes",
  到期: "Udløbet",
  是否选择做多: "Åbn long-position?",
  "可用余额为0 不能操作": "Saldo er 0, handling ikke mulig",
  福利中心: "Bonuscenter",
  奖励记录: "Belønningshistorik",
  我获取到的奖励: "Mine optjente belønninger",
  总价值: "Samlet værdi",
  新手任务: "Opgaver for nye brugere",
  身份认证: "Identitetsverifikation (KYC)",
  身份验证: "Identitetsverifikation",
  去验证: "Verificer nu",
  审核中: "Under behandling",
  已验证: "Verificeret",
  认证失败: "Verifikation mislykkedes",
  基础认证: "Grundlæggende verifikation",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Bemærk: Verificerede oplysninger kan ikke ændres. Indtast nøjagtige data.",
  "国家/地区": "Land/Region",
  请选择: "Vælg",
  证件类型: "Dokumenttype",
  证件编码: "Dokumentnummer",
  身份证: "ID-kort",
  护照: "Pas",
  驾驶证: "Kørekort",
  请输入编码: "Indtast nummer",
  名字: "Fornavn",
  请输入: "Indtast",
  中间名: "Mellemnavn",
  选填: "Valgfrit",
  姓氏: "Efternavn",
  中国: "Kina",
  身份上传: "Upload identitetsdokument",
  上传身份证: "Upload ID-kort",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Upload i JPG/JPEG/PNG-format. Sørg for, at billederne er klare, komplette og jævnt belyst. Maksimalt *MB.",
  确定提交: "Send",
  去认证: "Verificer",
  挑战任务: "Udfordringsopgaver",
  注册认证任务: "Registrerings- og verifikationsopgave",
  完成注册认证即可领取: "Fuldfør registrering og verifikation for at modtage",
  领取奖励: "Modtag belønning",
  新人豪礼: "Velkomstbonus",
  "参与人数：": "Antal deltagere:",
  条件: "Betingelse",
  入金量: "Indbetalingsbeløb",
  完成: "Fuldført",
  任务奖励: "Opgavebelønning",
  距任务更新: "Til opgaveopdatering",
  "条件：": "Betingelse:",
  活动规则: "Aktivitetsregler",
  奖励明细: "Belønningsdetaljer",
  已获得: "Optjent",
  交易奖励: "Handelsbelønning",
  Win奖励: "WIN-belønning",
  已领取: "Modtaget",
  亏损金额超过: "Tabsbeløb overstiger",
  单笔开仓金额超过: "Enkelt ordrebeløb overstiger",
  交易量: "Handelsvolumen",
  待完成: "Afventer",
  入金: "Indbetaling",
  盈利金额超过: "Gevinstbeløb overstiger",
  开仓金额: "Ordrebeløb",
  开仓金: "Ordrebeløb",
  盈利: "Gevinst",
  亏损: "Tab",
  领取: "Modtag",
  未领取: "Ikke modtaget",
  待领取: "Venter på modtagelse",
  再交易: "Handel videre",
  即可获得: "for at modtage",
  领取成功: "Modtaget",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Alle aktiviteter vil blive afregnet på slutdatoen. Belønninger udløber herefter.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Optjent afkast vil blive krediteret din bonus-konto, som du kan veksle eller hæve når som helst.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Belønningskryptovalutaen afhænger af opgaven.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Platformen har ret til endelig fortolkning. Ved snyd med opgaver vil belønninger blive tilbageholdt, og din konto kan blive frosset.",
  成长学院: "Akademi",
  "区块链 & 加密货币": "Blockchain & Kryptovaluta",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Din komplette guide til kryptovaluta. Vi følger dig på din kryptorejse.",
  "全仓合约定单的全部保证金。": "Samlet margin for krydsmargin futures-ordrer.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (urealiseret gevinst/tab - gebyrer - finansieringsrenter) = Netto værdi / Brugt margin * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Urealiseret gevinst/tab påvirker direkte 'tilgængelig margin'. Hvis urealiseret gevinst/tab øges, øges tilgængelig margin og omvendt.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (Brugt margin) + (urealiseret gevinst/tab - gebyrer - finansieringsrenter)",
  "注:可继续用于开仓的保证金。":
    "Bemærk: Margin, der er tilgængelig for at åbne nye positioner.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (urealiseret gevinst/tab - gebyrer - finansieringsrenter)",
  "注:当前的资金结余。": "Bemærk: Nuværende saldo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Henviser til den samlede saldo på futureskontoen, inklusive frosne beløb.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Bemærk: Jo højere risikoprocent, jo lavere risiko, og omvendt.",
  该功能尚未开发: "Denne funktion er stadig under udvikling",
  重置密码: "Nulstil adgangskode",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Indtast 8-20 tegn, inklusive bogstaver, tal og specialtegn",
  修改成功: "Ændring lykkedes",
  输入验证码: "Indtast bekræftelseskode",
  输入密码: "Indtast adgangskode",
  详情说明: "Detaljer",
  已售罄: "Udsolgt",
  剩余期限: "Resterende løbetid",
  限期: "Løbetid",
  闪兑货币选择: "Vælg valuta til hurtig veksling",
  地区选择: "Vælg region",
  "搜索国家/地区": "Søg efter land/region",
  "身份信息已提交，将在*小时内审核完成":
    "Identitetsoplysninger sendt. Behandling tager op til * timer.",
  "选择国家/地区": "Vælg land/region",
  "止盈价格需高于*": "Take-profit-pris skal være højere end *",
  "止损价格需低于*": "Stop-loss-pris skal være lavere end *",
  "止盈价格需低于*": "Take-profit-pris skal være lavere end *",
  "止损价格需高于*": "Stop-loss-pris skal være højere end *",
  教程详情: "Vejledningsdetaljer",
  请输入止损价: "Indtast stop-loss-pris",
  活期: "Fleksibel",
  赎回后立即到账: "Øjeblikkelig kreditering efter indfrielse",
  赎回: "Indfri",
  赎回理财: "Indfri finansprodukt",
  是否赎回当前的理财订单: "Indfri nuværende finansproduktordre?",
  维护: "Vedligeholdelse",
  "系统正在维护中……": "Systemet er under vedligeholdelse...",
  合约: "Futures",
  闪电兑换: "Hurtig veksling",
  流水挖矿: "Volumen-minedrift",
  邀请豪礼: "Invitationsbonus",
  计算器: "Beregner",
  最新价: "Seneste pris",
  涨跌幅: "Ændring (24h)",
  关注币种添加自选: "Tilføj kryptovaluta til favoritter",
  一键添加自选: "Tilføj til favoritter (ét klik)",
  全标已读: "Marker alle som læst",
  无消息: "Ingen beskeder",
  "暂时还没有收到任何消息通知哦!":
    "Du har ikke modtaget nogen notifikationer endnu!",
  没有更多数据: "Ingen flere data",
  闪兑: "Hurtig veksling",
  从: "Fra",
  "可用余额：": "Tilgængelig saldo:",
  至: "Til",
  预览兑换结果: "Forhåndsvis vekslingsresultat",
  闪兑规则: "Regler for hurtig veksling",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Hurtig veksling er underlagt markedsfluktuationer. Det faktisk modtagne beløb er bindende.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Vekslingskurser fastsættes af tredjepart. På grund af omkostninger og fluktuationer kan kursen afvige fra markedskursen. Kontroller omhyggeligt.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Platformen opkræver cirka *% gebyr per veksling for at dække omkostninger på børser.",
  确认汇兑: "Bekræft veksling",
  您预估得到: "Estimeret modtagelse",
  汇兑: "Veksling",
  汇兑比例: "Vekslingskurs",
  刷新: "Opdater",
  兑换: "Veksle",
  没有更多了: "Ingen flere data",
  搜索币种: "Søg efter kryptovaluta",
  可用: "Tilgængelig",
  我知道了: "Jeg forstår",
  最新价格: "Seneste pris",
  确认: "Bekræft",
  最大: "Maks",
  "风险率(%)": "Risikoprocent (%)",
  当前委托: "Aktuelle ordrer",
  合作交易历史记录: "Partner transaktionshistorik",
  重置: "Nulstil",
  余额: "Saldo",
  现货账户: "Spotkonto",
  合约账户: "Futureskonto",
  WIN账户: "WIN-konto",
  赏金账户: "Bonus-konto",
  总资产折合: "Samlede aktiver (i USDT)",
  今日收益: "Dagens afkast",
  充币: "Indbetaling",
  提币: "Udbetaling",
  账户权益: "Kontoværdi",
  "数量/类别": "Mængde/Kategori",
  全部币种: "Alle kryptovalutaer",
  全部类型: "Alle typer",
  账单信息: "Fakturainformation",
  理财赎回: "Indfrielse af finansprodukt",
  购买理财: "Køb af finansprodukt",
  收入: "Indtægter",
  支出: "Udgifter",
  到: "til",
  资产划转: "Overførsel af aktiver",
  "最少*": "Minimum *",
  "可用资产：": "Tilgængelige aktiver:",
  确认划转: "Bekræft overførsel",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Du skal overføre aktiver til den rigtige konto for at kunne handle. Overførsler mellem konti er gratis.",
  币种账户选择: "Vælg kryptovalutakonto",
  选择账户: "Vælg konto",
  划转详情: "Overførselsdetaljer",
  划转明细: "Overførselsspecifikationer",
  收入账单: "Indtægtsfaktura",
  支出账单: "Udgiftsfaktura",
  金额: "Beløb",
  总收益: "Samlet afkast",
  佣金: "Provision",
  用户名: "Brugernavn",
  "已领取：": "Modtaget:",
  "未领取：": "Ikke modtaget:",
  "请选择国家/地区": "Vælg land/region",
  请上传身份信息: "Upload identitetsoplysninger",
  请选择证件类型: "Vælg dokumenttype",
  请填写证件编码: "Indtast dokumentnummer",
  请填写名字: "Indtast fornavn",
  请填写姓氏: "Indtast efternavn",
  投资金额: "Investeringsbeløb",
  天: "dage",
  请输入手机号: "Indtast mobilnummer",
  搜索: "Søg",
  搜索历史: "Søgehistorik",
  热门推荐: "Populære anbefalinger",
  "《Xspace Earn协议》": "Xspace Earn-protokollen",
  我已了解并同意: "Jeg forstår og accepterer",
  协议: "Protokol",
  Xspace官方中文交流群: "Xspace officielt kinesisk fællesskab",
  Xspace官方英文交流群: "Xspace officielt engelsk fællesskab",
  预计维护至: "Forventet vedligeholdelse indtil",
  更多功能: "Flere funktioner",
  下载APP: "Download app",
  理财: "Finansprodukt",
  推荐: "Anbefalet",
  Telegram官方中文频道: "Officiel Telegram-kanal (kinesisk)",
  Telegram官方英文频道: "Officiel Telegram-kanal (engelsk)",
  官方邮箱: "Officiel e-mailadresse",
  客服邮箱: "Kundeservice e-mailadresse",
  上述信息最终解释权归官方所有:
    "Ovenstående oplysninger er underlagt officiel fortolkning af platformen.",
  IOS版下载: "Download til iOS",
  Android版下载: "Download til Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Transaktionsgebyr = Købsgebyr + Finansieringsrente + Salgsgebyr",
  资金划转: "Overførsel af midler",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Automatisk lukning",
  委托挂单: "Åben ordre",
  买: "Køb",
  卖: "Sælg",
  "买入/做多": "Køb/Long",
  "卖出/做空": "Sælg/Short",
  详情: "Detaljer",
  浮动涨跌: "Urealiseret gevinst/tab",
  最小: "Minimum",
  充币数量: "Indbetalingsmængde",
  请输入充币数量: "Indtast indbetalingsmængde",
  支付截图: "Betalingsbevis",
  提交: "Send",
  上传驾驶证: "Upload kørekort",
  上传护照: "Upload pas",
  加载中: "Indlæser...",
  上传成功: "Upload lykkedes",
  充值历史: "Indbetalingshistorik",
  合约卖出手续费: "Futures-salgsgebyr",
  合约买入手续费: "Futures-købsgebyr",
  系统加款: "Systemkreditering",
  系统减款: "Systemdebitering",
  合约资金费率: "Futures-finansieringsrente",
  佣金分成: "Provisionsdeling",
  U本位合约: "USDT-margin futures",
  资产管理: "Aktivforvaltning",
  APP下载: "Download app",
  全球领先的数字理财平台:
    "Verdens førende platform for digital formueforvaltning",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Handel øjeblikkeligt med Bitcoin, Ethereum og hundredvis af andre digitale aktiver",
  "24H涨跌幅": "24h ændring",
  查看更多行情: "Se flere markeder",
  近24小时成交量: "24h volumen",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Tilbyder hundredvis af spot- og futures-par. Over 20 millioner brugere i 200+ lande. En verdensførende digital aktivserviceplatform.",
  用户国家分布: "Brugere per land",
  用户数: "Antal brugere",
  交易对: "Handelspar",
  服务支持: "Support",
  "随时随地，多平台终端交易":
    "Handel hvor som helst med multi-platform support",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Kompatibel med flere enheder til alle handelsbehov.",
  随时查看实时行情: "Se realtidspriser hvor som helst",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Køb og sælg nemt BTC, ETH, DOGE og andre digitale aktiver",
  获取您关注的加密货币价格变化预警:
    "Modtag prisadvarsler for kryptovalutaer, du følger",
  "查看比特币现货、期货、期权价格":
    "Se Bitcoin spot-, futures- og optionspriser",
  比较各交易所加密货币价格: "Sammenlign kryptopriser på tværs af børser",
  开启您的数字货币之旅: "Start din rejse med digitale aktiver",
  快捷购买数字货币: "Køb kryptovaluta hurtigt",
  "使用多种支付方式交易数字货币，安全快捷":
    "Handel sikkert og hurtigt med flere betalingsmetoder",
  最优的交易费率: "De bedste transaktionsgebyrer",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Fordelagtige priser, konkurrencedygtige VIP-fordele og service af højeste kvalitet.",
  可信赖的安全保障: "Pålidelig sikkerhed",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Avancerede sikkerhedsforanstaltninger og SAFU-fonden beskytter dine aktiver mod risici.",
  交易: "Handel",
  币币市场: "Spotmarked",
  "24H成交量": "24h volumen",
  交易所: "Børs",
  "24H最高": "24h højeste",
  "24H最低": "24h laveste",
  永续合约: "Perpetual futures",
  日涨跌: "Daglig ændring",
  交易深度: "Ordredybde",
  "资产(合约)": "Aktiver (Futures)",
  历史仓位: "Positionshistorik",
  兑换记录: "Vekslingshistorik",
  类型: "Type",
  充值记录: "Indbetalingshistorik",
  划转记录: "Overførselshistorik",
  类别: "Kategori",
  历史账单: "Fakturahistorik",
  在线充值: "Online indbetaling",
  安全设置: "Sikkerhedsindstillinger",
  用于账户登录使用: "Bruges til kontologin",
  用户提现时安全验证使用: "Bruges til sikkerhedsverifikation ved udbetalinger",
  验证: "Verificer",
  万: "million",
  随时随地开启交易: "Begynd at handle hvor som helst",
  "*货币交易所的所有功能尽在你的手中。":
    "Alle funktioner på * kryptobørsen i din hånd.",
  "下载*货币交易所APP。": "Download * kryptobørs-appen.",
  下载自: "Download fra",
  内测版: "Betaversion",
  下载: "Download",
  扫码下载: "Scan for at downloade",
  设置您的资产密码: "Indstil din aktivadgangskode",
  法币: "Fiat",
  我要买: "Jeg vil købe",
  我要卖: "Jeg vil sælge",
  请输入金额: "Indtast beløb",
  汇率: "Vekslingskurs",
  获得: "Få",
  支付通道: "Betalingskanal",
  收款通道: "Modtagelseskanal",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Sørg for, at modtagelseskanalen er i dit navn, når du sælger.",
  当前法币暂不支持交易对可尝试前往提现:
    "Dette fiat-par understøttes i øjeblikket ikke. Prøv en udbetaling.",
  前往提现: "Gå til udbetaling",
  该法币暂无通道: "Ingen tilgængelig kanal for denne fiat-valuta",
  "正在出售中，请耐心等待": "Salg er i gang, vent venligst",
  请选择支付通道: "Vælg betalingskanal",
  请选择方式: "Vælg metode",
  法币历史: "Fiat-historik",
  买币: "Køb krypto",
  卖币: "Sælg krypto",
  失败: "Mislykkedes",
  已完成: "Fuldført",
  未付款: "Ubetalt",
  待审核: "Under behandling",
  打款中: "Udbetaling i gang",
  订单详情: "Ordredetaljer",
  联系客服: "Kontakt kundeservice",
  到账金额: "Modtaget beløb",
  通道: "Kanal",
  收款人: "Modtager",
  收款账户: "Modtagerkonto",
  "订单出售失败，请查下方失败原因":
    "Salg af ordre mislykkedes. Se årsagen nedenfor.",
  失败原因: "Årsag til fejl",
  您还未进行付款: "Du har ikke betalt endnu",
  您已成功购买: "Købet lykkedes",
  已取消订单: "Ordre annulleret",
  "订单正在审核中，请耐心等待": "Ordren behandles. Vent venligst.",
  您已成功出售: "Salget lykkedes",
  "订单正在打款中，请耐心等待": "Udbetaling i gang. Vent venligst.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "For betaling skal du besøge en anden platform. Vær opmærksom på din informationssikkerhed.",
  当前法币暂不支持交易对可尝试前往充值:
    "Dette fiat-par understøttes i øjeblikket ikke. Prøv en indbetaling.",
  前往充值: "Gå til indbetaling",
  购买: "Køb",
  订单号: "Ordrenummer",
  单价: "Enhedspris",
  到账数量: "Modtaget mængde",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Der er en ubetalt ordre. Vil du starte en ny betalingsordre?",
  继续支付: "Fortsæt betaling",
  重新下单: "Ny bestilling",
  是否确定出售: "Er du sikker på, at du vil sælge?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Efter bekræftelse vil platformen tildele en køber. Vent på matchningen.",
  出售: "Sælg",
  收款方式: "Modtagelsesmetode",
  订单已生成: "Ordre genereret",
  取消订单: "Annuller ordre",
  请在: "Venligst inden",
  内完成付款: "fuldfør betalingen",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Forlad platformen, log ind på din valgte betalingsmetode og overfør beløbet til sælgerens følgende konto. Angiv altid referencen:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Uden reference kan sælgeren ikke bekræfte betalingen, hvilket kan føre til tab af aktiver.",
  "未在规定的时间内付款，订单都将被取消。":
    "Hvis du ikke betaler inden den angivne tid, vil ordren blive annulleret.",
  姓名: "Navn",
  收款姓名: "Modtagerens navn",
  开户支行: "Bankfilial",
  银行卡号: "Bankkortnummer",
  "付款后，返回本平台": "Efter betaling, vend tilbage til denne platform",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Klik på knappen 'Jeg har fuldført betalingen, underret sælgeren'",
  未点击卖家不会放款:
    "Sælgeren vil først frigive kryptoen, efter du har klikket på knappen",
  交易条款: "Transaktionsbetingelser",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Midlerne til købet skal være lovlige og sikre",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Svindel, pyramidespil, gambling eller andre ulovlige midler er ikke tilladt",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Hvis midlerne fryses eller er mistænkelige efter transaktionen, vil vi ikke frigive USDT og vil give en refusion",
  "已付款，通知卖家": "Betalt, underret sælgeren",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Hvis du annullerer i alt * ordrer i dag, vil din købsret for dagen blive tilbagekaldt. Annuller denne ordre?",
  添加收款方式: "Tilføj modtagelsesmetode",
  是否删除此收款方式: "Slet denne modtagelsesmetode?",
  删除: "Slet",
  请选择法币: "Vælg fiat-valuta",
  机构名称: "Institutionens navn",
  请选择机构: "Vælg institution",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Din valgte modtagelsesmetode vil blive vist til købere, når du sælger krypto. Sørg for, at oplysningerne er korrekte.",
  请选择银行: "Vælg bank",
  请输入姓名: "Indtast navn",
  账号: "Kontonummer",
  请输入账号: "Indtast kontonummer",
  收款码: "Modtagelseskode",
  "银行账号/卡号": "Bankkonto/Kortnummer",
  "请输入银行账号/卡号": "Indtast bankkonto/kortnummer",
  "开户支行（选填）": "Bankfilial (valgfrit)",
  请输入开户支行: "Indtast bankfilial",
  "加入*官方频道": "Bliv medlem af den officielle *-kanal",
  关于: "Om",
  条款: "Betingelser",
  成功: "Lykkedes",
  等待: "Vent",
  作废: "Ugyldig",
  确认付款: "Bekræft betaling",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Betaling fuldført? Efter bekræftelse vil sælgeren bekræfte modtagelsen inden for * minutter.",
  最大金额: "Maksimalt beløb",
  最小金额: "Mindste beløb",
  付款: "Betal",
  法币充值: "Fiat-indbetaling",
  法币提现: "Fiat-udbetaling",
  待支付: "Venter på betaling",
  已支付: "Betalt",
  商户名: "Sælgerens navn",
  当前没有添加支付方式: "Ingen betalingsmetode tilføjet",
  添加后再出售: "Tilføj en, før du sælger",
  新人大礼包: "Velkomstpakke",
  注册即可领取: "Modtag efter registrering",
  立即领取: "Modtag nu",
  不再提示: "Vis ikke igen",
  "该奖励需在APP中领取，请下载APP":
    "Denne belønning kan kun modtages i appen. Download appen.",
  去交易: "Gå til handel",
  期权交易: "Optionshandel",
  交易额: "Handelsbeløb",
  可用额度: "Tilgængelig grænse",
  交易周期: "Handelsperiode",
  看涨: "Bullish (Call)",
  看跌: "Bearish (Put)",
  看空: "Short",
  当前持有: "Nuværende position",
  胜率: "Vindprocent",
  "盈利/亏损数": "Antal gevinst/tab-transaktioner",
  累计实现盈亏: "Realiserede samlede gevinst/tab",
  秒: "sekunder",
  分: "minutter",
  小时: "timer",
  周: "uge",
  下单时间: "Ordretid",
  剩余时间: "Resterende tid",
  买入价: "Købspris",
  结算价: "Afregningspris",
  实现盈利: "Realiserede gevinst",
  结算时间: "Afregningstid",
  期权: "Option",
  新手教程: "Vejledning for begyndere",
  我的订单: "Mine ordrer",
  赔率: "Odds",
  全部订单: "Alle ordrer",
  持有订单: "Åbne ordrer",
  历史订单: "Ordrehistorik",
  输入交易额度: "Indtast handelsbeløb",
  选择交易周期: "Vælg handelsperiode",
  去注册: "Registrer dig",
  冻结: "Frys",
  期权支出: "Optionsudgift",
  期权收入: "Optionsindtægt",
  用户提现: "Brugerudbetaling",
  "是否购买？": "Køb denne option?",
  购买成功: "Køb lykkedes",
  请签名: "Venligst underskriv",
  提交签名: "Send underskrift",
  清空签名: "Ryd underskrift",
  签名审核中: "Underskrift under behandling",
  已提交: "Sendt",
  扫一扫下载APP: "Scan for at downloade appen",
  新手领取大礼包: "Velkomstpakke for nye brugere",
  注册实名即送彩金: "Registrer og verificer for at modtage bonus",
  交易总额: "Samlet handelsvolumen",
  资产不足: "Utilstrækkelige aktiver",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Utilstrækkelige aktiver på WIN-kontoen. Du kan overføre aktiver fra din hovedkonto.",
  Win: "WIN",
  比赛: "Konkurrence",
  未开始: "Ikke startet",
  赛程: "Program",
  赛果: "Resultat",
  已结束: "Afsluttet",
  让球: "Handicap",
  进球数: "Mål",
  大: "Over",
  小: "Under",
  胜负平: "1X2 (Sejr/Uafgjort/Tab)",
  和局: "Uafgjort",
  投注: "Indsats",
  下注金额: "Indsatsbeløb",
  下注: "Placer indsats",
  阵容: "Holdopstilling",
  分析: "Analyse",
  输入下注金额: "Indtast indsatsbeløb",
  下注成功: "Indsats placeret",
  投注记录: "Indsatshistorik",
  未结算: "Ikke afregnet",
  已结算: "Afregnet",
  流水: "Omsætning",
  输赢: "Gevinst/Tab",
  赛时: "Kamp tid",
  下注时间: "Indsatstid",
  足彩竞猜: "Fodboldtips",
  查看详情: "Se detaljer",
  输: "Tab",
  赢: "Gevinst",
  主: "Hjemme",
  客: "Ude",
  主胜: "Hjemmesejr",
  客胜: "Udesejr",
  平: "Uafgjort",
  已延期: "Udsat",
  账号异常: "Kontoafvigelse",
  全场独赢: "Fuld tid 1X2",
  全场让球: "Fuld tid Handicap",
  全场大小: "Fuld tid Over/Under",
  总进球: "Samlet antal mål",
  拍摄照片要求: "Fotokrav",
  标准拍摄: "Standardbillede",
  边框缺失: "Manglende kant",
  照片模糊: "Uskarpt billede",
  闪光强烈: "For kraftigt blitz",
  上传手持证件照: "Upload billede med dokument i hånden",
  上传证件照: "Upload dokumentbillede",
  换一张: "Nyt billede",
  出生日期: "Fødselsdato",
  请选择出生日期: "Vælg fødselsdato",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Indtast bekræftelseskoden nedenfor for at få en e-mailkode til registrering.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Du har stadig * verifikationsforsøg tilbage. Efter denne grænse kan du ikke verificere dig.",
  上半场: "1. halvleg",
  下半场: "2. halvleg",
  独赢: "1X2",
  上半场独赢: "1. halvleg 1X2",
  下半场独赢: "2. halvleg 1X2",
  上半场让球: "1. halvleg Handicap",
  下半场让球: "2. halvleg Handicap",
  上半场大小球: "1. halvleg Over/Under",
  下半场大小球: "2. halvleg Over/Under",
  波胆: "Korrekt resultat",
  上半场波胆: "1. halvleg Korrekt resultat",
  下半场波胆: "2. halvleg Korrekt resultat",
  单双: "Ulige/Lige",
  单: "Ulige",
  双: "Lige",
  上半场单双: "1. halvleg Ulige/Lige",
  下半场单双: "2. halvleg Ulige/Lige",
  上半场总进球: "1. halvleg Samlet mål",
  下半场总进球: "2. halvleg Samlet mål",
  中场: "Halvleg",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Bemærk: For billedet med dokument i hånden, skriv teksten på et hvidt ark papir og fotografer det sammen med dit dokument, som i eksemplet.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "For nylig er mange svigagtige konti blevet straffet. Kontakt kundeservice, hvis du mener, at din konto er blevet uretfærdigt straffet.",
  最小下注金额: "Mindste indsats",
  参与活动最小下注金额: "Mindste indsats for at deltage i aktiviteten",
  记住密码: "Husk adgangskode",
  比分: "Resultat",
  "您还未登录，请先登录": "Du er ikke logget ind. Log ind først.",
  立即登录: "Log ind nu",
  下注限额: "Indsatsgrænse",
  可赢金额: "Beløb, der kan vindes",
  闪兑详情: "Detaljer for hurtig veksling",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "På grund af valutakursfluktuationer kan det endelige indsatsbeløb afvige. Ordren er bindende.",
  开赛时间: "Starttid",
  足球收入: "Fodboldindtægter",
  足球支出: "Fodboldudgifter",
  活动详情: "Aktivitetsdetaljer",
  为世界杯喝彩: "Støt verdensmesterskabet",
  我的竞猜: "Mine tips",
  "竞猜比赛、有机会瓜分*USDT": "Tip om kampe og vind en del af * USDT",
  "瓜分*USDT": "Del * USDT",
  距离活动结束还有: "Aktivitet slutter om:",
  我的门票: "Mine billetter",
  竞猜结束时间: "Slut på tips",
  猜比分: "Tip resultat",
  "福利派送中，完成任务即可获取门票":
    "Bonusser uddeles. Fuldfør opgaver for at tjene billetter.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Fuldfør følgende opgaver for at få det tilsvarende antal billetter til at deltage i konkurrencen.",
  时: "time",
  活动: "Aktivitet",
  竞猜记录: "Tipshistorik",
  结果: "Resultat",
  任务: "Opgave",
  去邀请: "Inviter",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Tip om resultatet for hver kamp og vind en del af $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "En billet er nødvendig for at tipse. Billetter kan tjenes ved at fuldføre platformens opgaver.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Efter et vellykket tip, send et skærmbillede til kundeservice. De vil kreditere bonusen til din konto, som du straks kan hæve.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Snyd er forbudt. Hvis det opdages, vil belønningen blive ugyldig.",
  "完成任务后，点击咨询客服获得门票。":
    "Efter at have fuldført opgaverne, klik på 'Kontakt kundeservice' for at få billetter.",
  继续猜: "Fortsæt med at tipse",
  总单数: "Samlet antal væddemål",
  赛事筛选: "Filtrer efter begivenhed",
  球队筛选: "Filtrer efter hold",
  总金额: "Samlet beløb",
  总流水: "Samlet omsætning",
  派奖金额: "Bonusbeløb udbetalt",
  下注单数: "Antal væddemål",
  利润: "Fortjeneste",
  更多福利: "Flere bonusser",
  我的奖金: "Min bonus",
  未认证: "Ikke verificeret",
  总量: "I alt",
  或: "eller",
  模拟交易: "Demohandel",
  体验账户不可操作: "Ikke tilgængelig på demokonto",
  世界杯比分竞猜: "VM-resultattips",
  "领*USDT起": "Modtag fra * USDT",
  消息: "Beskeder",
  滚球: "Live-væddemål",
  是: "Ja",
  不是: "Nej",
  当前余额: "Nuværende saldo",
  KOL招募: "KOL-rekruttering",
  本月净输赢: "Netto gevinst/tab denne måned",
  本月佣金: "Provision denne måned",
  佣金比例: "Provisionsprocent",
  活跃人数: "Aktive brugere",
  新增下级: "Nye nedlinjer",
  登录人数: "Loggede brugere",
  首存人数: "Brugere med første indbetaling",
  数据分析: "Dataanalyse",
  人数: "Antal personer",
  新注册存款金额: "Indbetalingsbeløb for nye registreringer",
  老用户存款金额: "Indbetalingsbeløb for eksisterende brugere",
  首存金额: "Første indbetalingsbeløb",
  快捷入口: "Hurtig adgang",
  成员管理: "Medlemsadministration",
  财务报表: "Finansielle rapporter",
  分红报表: "Udbytterapport",
  订单记录: "Ordrehistorik",
  VIP专享: "VIP-eksklusivt",
  推广工具: "Markedsføringsværktøjer",
  计算规则: "Beregningsregler",
  账变明细: "Transaktionsdetaljer",
  成员: "Medlemmer",
  下级概览: "Oversigt over nedlinjer",
  下级成员总计: "Samlet nedlinjer",
  本月新增: "Nye denne måned",
  本月活跃会员: "Aktive medlemmer denne måned",
  今日活跃会员: "Aktive medlemmer i dag",
  本月有效活跃: "Effektivt aktive denne måned",
  活跃成员占比: "Andel aktive medlemmer",
  本月活跃: "Aktive denne måned",
  今日活跃: "Aktive i dag",
  下级成员: "Nedlinjer",
  会员账号: "Medlemskonto",
  统计时间: "Statistiktid",
  筛选: "Filtrer",
  存款: "Indbetaling",
  取款: "Udbetaling",
  总输赢: "Samlet gevinst/tab",
  是否有效用户: "Aktiv bruger?",
  最近登录时间: "Seneste login",
  否: "Nej",
  开始时间: "Starttid",
  结束时间: "Sluttid",
  提取: "Udbetal",
  总盈亏: "Samlet resultat",
  净盈亏: "Nettoresultat",
  分红: "Udbytte",
  概览: "Oversigt",
  月度详细数据: "Månedlige detaljerede data",
  未发放: "Ikke udbetalt",
  活跃用户: "Aktive brugere",
  有效新增会员: "Effektive nye medlemmer",
  冲正后净输赢: "Netto gevinst/tab efter korrektion",
  上月结余: "Saldo forrige måned",
  净输赢: "Netto gevinst/tab",
  "系统每日新加坡时间1:00更新一次报表":
    "Rapporter opdateres dagligt kl. 01:00 Singapore-tid.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "I rapporter betyder positive tal fortjeneste for partneren, negative tal betyder tab for partneren.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Provisionsdata opdateres dagligt, er vejledende og udgør ikke en endelig udbetalingsgrundlag.",
  选择时间: "Vælg tid",
  足球: "Fodbold",
  投注金额: "Indsatsbeløb",
  有效订单: "Gyldige ordrer",
  下级账户: "Nedlinjekonto",
  待成交: "Afventer",
  下单金额: "Ordrebeløb",
  订单内容: "Ordreindhold",
  秒数: "Sekunder",
  联赛: "Liga",
  队伍: "Hold",
  比赛时间: "Kampstart",
  玩法: "Spiltype",
  等级规则表: "Niveauregeltabel",
  等级: "Niveau",
  活跃会员: "Aktive medlemmer",
  最新活跃: "Seneste aktivitet",
  额外佣金: "Ekstra provision",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Månedligt baseret på vækststandarder. Du kan kun drage fordel af ét niveau.",
  渠道生成: "Generer kanal",
  创建: "Opret",
  渠道名称: "Kanalnavn",
  注册人数: "Antal registreringer",
  浏览人数: "Antal visninger",
  构建状态: "Byggestatus",
  禁用: "Deaktiver",
  启用: "Aktiver",
  查看: "Se",
  创建渠道: "Opret kanal",
  创建成功: "Oprettelse lykkedes",
  操作成功: "Handling lykkedes",
  渠道详情: "Kanaldetaljer",
  邀请码: "Invitationskode",
  访问人数: "Antal besøgende",
  渠道地址: "Kanaladresse",
  我的福利: "Mine bonusser",
  充值福利: "Indbetalingsbonus",
  当前流水: "Nuværende omsætning",
  如何参与: "Sådan deltager du",
  币种充值: "Kryptovalutaindbetaling",
  充值福利中领取福利: "Modtag bonus ved indbetalingsbonus",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regel: Indbetalingsbonusen er frivillig, gyldig i 24 timer efter indbetaling. Efter modtagelse vil udbetaling midlertidigt blive blokeret, indtil omsætningskravet er nået.",
  失效日期: "Udløbsdato",
  "暂无福利领取，充值后领取":
    "Ingen bonus tilgængelig. Modtag efter indbetaling.",
  参与: "Deltag",
  充值赠送: "Indbetalingsbonus",
  "领取*%的赠送": "Modtag *% bonus",
  去领取: "Modtag",
  VIP奖励: "VIP-belønning",
  "当前可领取*USDT，是否确认领取":
    "* USDT tilgængelig for modtagelse. Bekræft?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Efter modtagelse vil udbetaling midlertidigt blive blokeret, indtil en omsætning på * USDT er nået.",
  充值送大礼: "Indbetalingsgave",
  "存入越多，送越多！": "Jo mere du indbetaler, jo større gave!",
  无效: "Ugyldig",
  有效: "Gyldig",
  总存金额: "Samlet indbetalt beløb",
  提示: "Bemærk",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positive tal i samlet og netto gevinst/tab betyder platformsfotjeneste. Daglige data er vejledende.",
  "净盈亏：总盈亏-用户返水":
    "Nettoresultat: Samlet resultat - Cashback til bruger",
  盈利方: "Fortjenestepart",
  代理: "Agent",
  客户: "Kunde",
  平局: "Uafgjort",
  平台: "Platform",
  "已提交审核，请耐心等待": "Sendt til verifikation. Vent venligst.",
  充值日期: "Indbetalingsdato",
  平台本月总输赢: "Platformens samlede gevinst/tab denne måned",
  KOL招募合作: "KOL-rekrutteringssamarbejde",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Platformen åbner KOL-rekruttering. Med en social mediekonto kan du nyde udbytte og livslang indkomst gennem engangskundehvervning.",
  级别: "Niveau",
  平台利润返佣: "Platforms fortjenesteprovision",
  佣金案例: "Provisionseksempel",
  交易项目: "Handelsprodukter",
  "期权交易、合约交易、足球游戏": "Optionshandel, futureshandel, fodboldspil",
  报名方式: "Tilmeldingsmetode",
  点击KOL招募报名: "Klik for at tilmelde dig KOL-rekruttering",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Velkommen til vores team. Vi støtter dig i at opbygge dit eget bruger system. Tjen op til *% provision. Vi ser frem til din deltagelse.",
  输入联系方式: "Indtast kontaktoplysninger",
  最低活跃人数: "Minimum antal aktive brugere",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "F.eks.: Hvis aktive brugere denne måned ≥ * og platformens samlede gevinst/tab ≥ * USDT, tilhører du niveau * og får *% provision.",
  比分竞猜: "Resultattips",
  豪礼相赠: "Stor gave",
  足球活动: "Fodboldaktivitet",
  圣诞节活动: "Juleaktivitet",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Du har deltaget i en aktivitet. Udbetaling er midlertidigt blokeret. Du har stadig brug for * USDT i omsætning for at låse op.",
  剩余流水: "Resterende omsætning",
  助力足球: "Støt fodbold",
  佣金累计: "Samlet provision",
  有效投注: "Gyldige væddemål",
  今日: "I dag",
  今日返水: "Cashback i dag",
  VIP返水: "VIP-cashback",
  返水记录: "Cashback-historik",
  成员信息: "Medlemsinformation",
  基本信息: "Grundlæggende oplysninger",
  钱包余额: "Pung saldo",
  投注信息: "Væddemålsinformation",
  返水: "Cashback",
  总下注: "Samlet indsats",
  今日输赢: "Gevinst/tab i dag",
  下注动态: "Væddemålsaktivitet",
  返水奖励: "Cashback-belønning",
  分红金额: "Udbyttebeløb",
  返水支出: "Cashback-udgift",
  总返水: "Samlet cashback",
  流水总额: "Samlet omsætning",
  返水总额: "Samlet cashback",
  返水详情: "Cashback-detaljer",
  日流水: "Daglig omsætning",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platformen giver ekstra cashback baseret på daglig omsætning af dine nedlinjer. Udbetaling dagligt kl. 00:00 Singapore-tid til bonus-konto.",
  "申请成功，等待审核": "Ansøgning lykkedes, venter på verifikation",
  "我出本金，盈利共分享": "Jeg giver kapital, fortjeneste deles",
  最高分红: "Maksimalt udbytte",
  投资大师比赛: "Master Investor-konkurrence",
  "我出本金，你盈利": "Jeg giver kapital, du tjener",
  共分享: "Del sammen",
  最高分红可得: "Maksimalt muligt udbytte",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Eksklusiv velkomstbonus: $* gratis. Efter modtagelse kan du investere i ethvert projekt. Fortjeneste kan straks hæves.",
  报名领取: "Tilmeld dig og modtag",
  审核驳回: "Verifikation afvist",
  驳回原因: "Årsag til afvisning",
  活动运行周期: "Aktivitetsperiode",
  "申请成功后起至*天内完成超额收益。":
    "Opnå overafkast inden for * dage efter godkendelse.",
  分红比: "Udbytteandel",
  "*日获得盈利后，可获得*%的收益额。":
    "Efter at have opnået fortjeneste på dag *, får du *% af afkastbeløbet.",
  参与条件: "Deltagelsesbetingelser",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Brugere fra Rusland eller Tyrkiet, der ikke har deltaget endnu.",
  计算项目: "Beregnede produkter",
  "合约、体育、期权": "Futures, Sport, Optioner",
  我的投资: "Mine investeringer",
  参与天数: "Deltagelsesdage",
  累计下注: "Samlet indsats",
  累计盈亏: "Samlet gevinst/tab",
  预计可分红: "Forventet udbytte",
  常见问题: "Ofte stillede spørgsmål (FAQ)",
  什么是平台出资: "Hvad er platformfinansiering?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Platformen giver gratis midler til brugere fra specifikke lande til at investere i projekter.",
  怎么获取平台出资的福利: "Hvordan får jeg platformfinansieringsbonusen?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Hvis du er fra et af de angivne lande, skal du klikke på tilmeldingsknappen. Efter godkendelse vil * USDT blive overført til din bonus-konto, som du kan overføre for at investere.",
  什么是分红: "Hvad er udbytte?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Udbytte: Hvis afkastet når 100% inden for den angivne tid, får du 50% af overafkastet. F.eks.: Modtag 100 USDT, opnå 120% afkast, så er 20% overafkast.",
  "如何取得分红？": "Hvordan får jeg udbytte?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Aktivitetscyklus er hver * dag. Efter afslutning foretages afregning. Hvis du opfylder kravene, sendes udbyttet til bonus-kontoen. Hvis ikke, vil dit afkast og platformfinansieringen blive fjernet.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Deltagende konti skal være KYC-verificerede. Kun én bonus pr. konto.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC for deltagelse er kun gyldig for angivne lande. Kontroller, om dit land matcher aktivitetslandet.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Efter vellykket deltagelse vil udbetaling midlertidigt blive blokeret, indtil aktiviteten er afsluttet.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Følg aktivitetsreglerne. Ved snyd eller misbrug af systemfejl vil alle midler på din konto blive permanent frosset.",
  平台出资: "Platformfinansiering",
  平台出资收回: "Platformfinansiering tilbagekaldt",
  投资大师奖励: "Master Investor-belønning",
  请下载APP添加收款方式: "Download appen for at tilføje modtagelsesmetode",
  请下载APP进行身份验证: "Download appen for at udføre identitetsverifikation",
  请下载APP参与: "Download appen for at deltage",
  技术指标: "Tekniske indikatorer",
  主图: "Hoveddiagram",
  副图: "Sekundært diagram",
  新注册人数: "Nye registreringer",
  老用户存款人数: "Eksisterende brugere, der indbetaler",
  存款人数: "Antal indbetalinger",
  取款人数: "Antal udbetalinger",
  投注人数: "Antal væddemål",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Eksklusive brugere fra Indonesien, Indien, Bangladesh, der ikke har deltaget endnu.",
  市场动态: "Markedsdynamik",
  外汇合约: "Forex-futures",
  盈亏比: "Gevinst/tab-forhold",
  委托价: "Ordrepris",
  可用余额: "Tilgængelig saldo",
  持仓额: "Positionsværdi",
  强平价: "Likvidationspris",
  修改: "Rediger",
  修改价位: "Rediger pris",
  外汇: "Forex",
  外汇账户: "Forexkonto",
  我的交易: "Mine transaktioner",
  未设置: "Ikke indstillet",
  超出最大可设数值: "Overskrider maksimal indstillelig værdi",
  超出最小可设数值: "Under minimal indstillelig værdi",
  止盈超出最小可设数值: "Take-profit under minimal indstillelig værdi",
  止损超出最大可设数值: "Stop-loss overskrider maksimal indstillelig værdi",
  止盈超出最大可设数值: "Take-profit overskrider maksimal indstillelig værdi",
  止损超出最小可设数值: "Stop-loss under minimal indstillelig værdi",
  挖矿: "Minedrift",
  交易账户: "Handelskonto",
  买涨: "Køb (Long)",
  买跌: "Sælg (Short)",
  请输入正确的银行卡信息: "Indtast korrekte bankkortoplysninger",
  联系在线客服: "Kontakt live kundeservice",
  法币交易请联系在线客服: "Kontakt kundeservice for fiat-handel",
  提交订单: "Send ordre",
  "支付过程如有疑问,请联系在线客服":
    "Kontakt kundeservice, hvis du har spørgsmål om betalingsprocessen",
  彩金赠送: "Bonustildeling",
  在线客服: "Live chat",
  最少投资: "Minimumsinvestering",
  "提交时间:": "Indsendelsestid:",
  提现拒绝: "Udbetaling afvist",
  认证拒绝: "Verifikation afvist",
  认证通过: "Verifikation godkendt",
  请输入正确的交易额度: "Indtast et gyldigt handelsbeløb",
  最大下注金额: "Maksimal indsats",
  手机号: "Mobilnummer",
  邮箱注册: "Registrer med e-mail",
  手机号注册: "Registrer med mobilnummer",
  查询: "Søg",
  手机号登录: "Log ind med mobilnummer",
  邮箱登录: "Log ind med e-mail",
  请输入数量: "Indtast mængde",
  可用数量: "Tilgængelig mængde",
  钱包登录: "Log ind med pung",
  请输入正确的邀请码: "Indtast en gyldig invitationskode",
  "请输入邀请码(必填)": "Indtast invitationskode (obligatorisk)",
  输入正确的金额: "Indtast et gyldigt beløb",
  法币充值: "Fiat-indbetaling",
  卢比充值: "Indisk rupi-indbetaling",
  请输入法币: "Indtast fiat-beløb",
  请输入IFSC: "Indtast IFSC-kode",
  "银行编码(选填)": "Bankkode (valgfrit)",
  请输入银行编码: "Indtast bankkode",
  请输入大于8位数的密码: "Indtast en adgangskode med mere end 8 tegn",
  添加成功: "Tilføjet",
  "60秒": "60 sekunder",
  "180秒": "180 sekunder",
  "300秒": "300 sekunder",
  "2次密码不一致": "Adgangskoderne er ikke ens",
  输入提币数量: "Indtast udbetalingsmængde",
  图片格式不正确: "Ugyldigt billedformat",
  图片大于20M: "Billedet er større end 20 MB",
  请设置委托价格: "Indstil en ordrepris",
  输入资金密码: "Indtast aktivadgangskode",
  验证码错误: "Forkert bekræftelseskode",
  充值拒绝: "Indbetaling afvist",
  请输入SSN: "Indtast SSN",
  结算完成: "Afregning fuldført",
  继续下单: "Fortsæt med at bestille",
  限价: "Limitordre",
  买入价格: "Købspris",
  买入量: "Købsmængde",
  卖出价格: "Salgspris",
  卖出量: "Salgsmængde",
  买入: "Køb",
  卖出: "Sælg",
  订单创建成功: "Ordre oprettet",
  币币买入支出: "Udgift til spotkøb",
  币币买入支出退还: "Refusion af udgift til spotkøb",
  币币买入获得: "Modtagelse fra spotkøb",
  币币卖出支出: "Udgift til spotsalg",
  币币卖出支出退还: "Refusion af udgift til spotsalg",
  币币卖出获得: "Modtagelse fra spotsalg",
  币币交易手续费: "Spot transaktionsgebyr",
  请输入限价: "Indtast limitpris",
  成交: "Udført",
  等待成交: "Venter på udførelse",
  交易完成: "Transaktion fuldført",
  被取消: "Annulleret",
  交易时间: "Transaktionstid",
  法币交易: "Fiat-handel",
  法币出售: "Fiat-salg",

  两次密码不一致: "Adgangskoderne er ikke ens",
  再次输入账户密码: "Indtast kontoadgangskoden igen",

  美国: "USA",
  韩国: "Sydkorea",
  阿尔巴尼亚: "Albanien",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Jemen",
  美属维尔京群岛: "Amerikanske Jomfruøer",
  英属处女群岛: "Britiske Jomfruøer",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Usbekistan",
  乌拉圭: "Uruguay",
  英国: "Storbritannien",
  阿拉伯联合酋长国: "Forenede Arabiske Emirater",
  乌克兰: "Ukraine",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks- og Caicosøerne",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Tyrkiet",
  突尼斯: "Tunesien",
  特立尼达和多巴哥: "Trinidad og Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Østtimor",
  泰国: "Thailand",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tadsjikistan",
  中国台湾: "Taiwan",
  叙利亚: "Syrien",
  瑞士: "Schweiz",
  瑞典: "Sverige",
  斯威士兰: "Eswatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spanien",
  南非: "Sydafrika",
  索马里: "Somalia",
  所罗门群岛: "Salomonøerne",
  斯洛文尼亚: "Slovenien",
  斯洛伐克: "Slovakiet",
  "圣马丁岛（荷兰部分）": "Sint Maarten (hollandske del)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychellerne",
  塞尔维亚: "Serbien",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudi-Arabien",
  圣多美和普林西比: "São Tomé og Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts og Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent og Grenadinerne",
  圣彼埃尔和密克隆岛: "Saint-Pierre og Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts og Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Rusland",
  罗马尼亚: "Rumænien",
  留尼汪: "Réunion",
  刚果共和国: "Republikken Congo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polen",
  菲律宾: "Filippinerne",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua Ny Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palæstina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norge",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "New Zealand",
  新喀里多尼亚: "Ny Kaledonien",
  荷属安德列斯群岛: "Nederlandske Antiller",
  荷兰: "Holland",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mozambique",
  摩洛哥: "Marokko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongoliet",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldova",
  墨西哥: "Mexico",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauretanien",
  马里亚纳群岛: "Marianerne",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldiverne",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Nordmakedonien",
  中国澳门: "Macao",
  卢森堡: "Luxembourg",
  立陶宛: "Litauen",
  列支敦士登: "Liechtenstein",
  利比亚: "Libyen",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Letland",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgisistan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kasakhstan",
  约旦: "Jordan",
  日本: "Japan",
  牙买加: "Jamaica",
  象牙海岸: "Elfenbenskysten",
  意大利: "Italien",
  以色列: "Israel",
  爱尔兰: "Irland",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesien",
  印度: "Indien",
  冰岛: "Island",
  匈牙利: "Ungarn",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grønland",
  希腊: "Grækenland",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Tyskland",
  格鲁吉亚: "Georgien",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Fransk Polynesien",
  法属圭亚那: "Fransk Guyana",
  法国: "Frankrig",
  芬兰: "Finland",
  斐济: "Fiji",
  法罗群岛: "Færøerne",
  埃塞俄比亚: "Etiopien",
  爱沙尼亚: "Estland",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Ækvatorialguinea",
  萨尔瓦多: "El Salvador",
  埃及: "Egypten",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominikanske Republik",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Danmark",
  捷克: "Tjekkiet",
  塞浦路斯: "Cypern",
  库拉索: "Curaçao",
  古巴: "Cuba",
  克罗地亚: "Kroatien",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Elfenbenskysten",
  库克群岛: "Cookøerne",
  科摩罗: "Comorerne",
  哥伦比亚: "Colombia",
  智利: "Chile",
  乍得: "Tchad",
  中非共和国: "Centralafrikanske Republik",
  佛得角: "Kap Verde",
  开曼群岛: "Caymanøerne",
  开普: "Cape",
  加拿大: "Canada",
  喀麦隆: "Cameroun",
  柬埔寨: "Cambodja",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgarien",
  文莱: "Brunei",
  巴西: "Brasilien",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnien-Hercegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgien",
  白俄罗斯: "Hviderusland",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Aserbajdsjan",
  奥地利: "Østrig",
  澳大利亚: "Australien",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenien",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua og Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikansk Samoa",
  阿尔及利亚: "Algeriet",
  中国: "Kina",
  余额不足: "Utilstrækkelig saldo",
  最低购买: "Minimumskøb",
  最高购买: "Maksimumskøb",
  下单成功: "Ordre afgivet",
  平仓成功: "Position lukket",
  请输入正确的平仓数量: "Indtast en gyldig lukningsmængde",
  加仓成功: "Position øget",
  请输入正确的加仓金额: "Indtast et gyldigt beløb for at øge positionen",
  收藏成功: "Tilføjet til favoritter",
  取消收藏成功: "Fjernet fra favoritter",
  加密币永续: "Kryptovaluta perpetual",
  外汇永续: "Forex perpetual",
  期权账户: "Optionskonto",
  快捷卖币: "Hurtigt salg af krypto",

  托管资金: "Forvaltede midler",
  托管中: "Under forvaltning",
  预计日收益: "Estimeret dagligt afkast",
  累计收益: "Samlet afkast",
  周期: "Løbetid",
  日收益: "Dagligt afkast",
  限额: "Grænse",
  立即托管: "Start forvaltning nu",
  "已鎖定 請聯繫客服": "Låst. Kontakt kundeservice.",
  产品列表: "Produktliste",
  规则: "Regler",
  创建订单: "Opret ordre",
  产品名称: "Produktnavn",
  托管周期: "Forvaltningsperiode",
  等级限制: "Niveaubegrænsning",
  托管金额: "Forvaltet beløb",
  限额: "Grænse",
  余额: "Saldo",
  购买日: "Købsdato",
  起息日: "Rentestartdato",
  派息时间: "Renteudbetalingstid",
  每天: "Dagligt",
  计息结束日: "Renteslutdato",
  每日收益: "Dagligt afkast",
  预计收益: "Estimeret afkast",
  "收益将自动发送至您的余额账户;": "Afkast sendes automatisk til din saldo;",
  "您的资金没有任何风险;": "Dine midler er uden risiko;",
  "365*24小时不断地工作;": "Arbejder 24/7, 365 dage om året;",
  托管中: "Under forvaltning",
  结束: "Afsluttet",
  今日收益: "Dagens afkast",
  剩余周期: "Resterende løbetid",
  进行中: "Aktiv",
  已发放: "Udbetalt",
  信誉分: "Omdømmepoint",

  复制成功: "Kopieret succesfuldt",
  VIP权益: "VIP-fordele",
  旧密码: "Gammel adgangskode",
  请输入旧密码: "Indtast venligst din gamle adgangskode",
  "忘记旧密码请联系客服重置。":
    "Hvis du har glemt din gamle adgangskode, bedes du kontakte kundeservice for at nulstille den.",
  去升级: "Opgrader",
  描述: "Beskrivelse",
  实际存款金额: "Faktisk indbetalingsbeløb",
  升级礼金: "Opgraderingsbonus",
  隔夜利息: "Overnattensrente (swap)",
  自动结算: "Automatisk afregning",
  等级规则: "Niveauregler",
  "WEB3.0币持有数据收益": "Dataafkast fra WEB3.0-møntbeholdning",
  总生产: "Samlet produktion",
  有效节点: "Aktive knuder",
  参与人: "Deltagere",
  用户收益: "Brugerafkast",
  "流动性WEB3.0输出": "Likviditets-WEB3.0-output",
  总资产: "Samlede aktiver",

  ETHAI持有数据收益: "ETHAI besiddelse dataafkast",
  AI量化流动性: "AI kvantitativ likviditet",
  现货买入手续费: "Spot købsgebyr",
  现货支出: "Spot udgift",
  现货资金费率: "Spot finansieringssats",
  现货卖出手续费: "Spot salgsgebyr",
  现货收入: "Spot indtægt",
  外汇合约支出: "Valutaterminskontrakt udgift",
  外汇合约买入手续费: "Valutaterminskontrakt købsgebyr",
  外汇合约资金费率: "Valutaterminskontrakt finansieringssats",
  外汇合约卖出手续费: "Valutaterminskontrakt salgsgebyr",
  外汇合约收入: "Valutaterminskontrakt indtægt",
  理财购买: "Investeringsprodukt køb",
  VIP理财日收益: "VIP investeringsprodukt dagligt afkast",
  VIP理财隔夜利息: "VIP investeringsprodukt overnight rente",
  VIP本金返还: "VIP tilbagebetaling af hovedstol",
  VIP彩金发放: "VIP bonus udbetaling",
  VIP彩金抵扣: "VIP bonus modregning",
  隔夜利息: "Overnight rente",
  设置资产密码: "Indstil aktivadgangskode",

  锁仓挖矿: "Låst mining",
  一站式理财服务: "Alt-i-en finansiel service",
  产品: "Produkter",
  客服中心: "Kundeservicecenter",
  贷款: "Lån",
  挖矿赚不停: "Tjen løbende på mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Låst mining foregår ved at overdrage USDT (USD:1USDT=1USD) til platformens højtydende miningmaskiner for at opnå miningindtægter i platformens miningpool.",
  产品优势: "Produktfordele",
  随存随取: "Indsæt og hæv når som helst",
  锁仓周期: "Bindingsperiode",
  每日下发: "Daglig udbetaling",
  随机空投: "Tilfældigt airdrop",
  "100%资金安全保障": "100% sikkerhedsgaranti for midler",
  "100%节假日收益不间断": "100% uafbrudt indtjening selv på helligdage",
  成功锁仓后当天产出: "Indtjening starter samme dag efter vellykket binding",
  关于违约金: "Om gebyr ved misligholdelse",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Hvis du ønsker at hæve hovedstolen før udløb, vil der blive opkrævet et gebyr ved misligholdelse. Gebyr = misligholdelsesprocent × resterende dage × låst beløb.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Eksempel: Misligholdelsesprocenten for denne låste mining er 5 %, der er 3 dage tilbage til udløb, og det låste beløb er 10000U (USDT/USD). Gebyret bliver derfor 5%×3×10000=1500U, og den faktiske tilbagebetaling bliver 15000U-1500U.",
  收益计算: "Beregning af indtjening",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Platformen tilbyder flere låste mining-finansprodukter. Beregningen af indtjening er som følger, eksempel:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Hvis et medlem låser 10000U (USDT, USD) på platformen og vælger et 7-dages produkt med en daglig indtjening på 0,7%~1,8% af det låste beløb, bliver den daglige indtjening som følger:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maksimum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Efter 7 dage kan der opnås en indtjening på 490U~1260U. Indtjeningen udbetales dagligt, og den låste hovedstol overføres automatisk til din finansielle konto ved udløb.",
  正在托管的资金: "Midler under forvaltning",
  签到: "Check ind",
  锁仓订单: "Låste ordrer",
  预计今日收益: "Forventet indtjening i dag",
  累计收益: "Samlet indtjening",
  托管中的订单: "Ordrer under forvaltning",
  单笔最少: "Minimum pr. ordre",
  单笔最多: "Maksimum pr. ordre",
  日收益率: "Daglig afkastprocent",
  说明: "Beskrivelse",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistikker beregnes efter GMT+8<br>2. Daglig indtjening beregnes ud fra alle afsluttede ordrer mellem 00:00-23:59 GMT+8 (lokal tid 00:00-23:59)<br>3. Dagens indtjening udbetales samlet næste dag mellem 00:00-00:10 GMT+8.",
  知道了: "Forstået",
  锁仓: "Lås",
  派息时间: "Tidspunkt for udbetaling",
  每日: "Dagligt",
  托管资金: "Forvaltede midler",
  到期返回: "Returneres ved udløb",
  提前赎回: "Tidlig indløsning",
  预计收益: "Forventet indtjening",
  认购: "Tegning",
  热门: "Populær",
  数字货币: "Digitale valutaer",
  贵金属: "Ædelmetaller",
  大宗商品: "Råvarer",
  持仓明细: "Positionsdetaljer",
  历史明细: "Historik",
  当前价: "Aktuel pris",
  "↑买涨": "↑ Køb stigning",
  "↓买跌": "↓ Køb fald",
  显示全部: "Vis alle",
  买入金额: "Købsbeløb",
  方向: "Retning",
  收益: "Indtjening",
  预期收益: "Forventet indtjening",
  估用保证金: "Estimeret margin",
  确认下单: "Bekræft ordre",
  锁定: "Låst",
  账户总资产: "Samlede kontoaktiver",
  明细: "Detaljer",
  今日收益: "Dagens indtjening",
  仓位保证金: "Positionsmargin",
  持有仓位: "Åbne positioner",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Låst beløb = summen af alle ikke-afsluttede låste miningordrer",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistikker beregnes efter GMT+8<br>2. Daglig indtjening beregnes ud fra alle afsluttede ordrer mellem 00:00-23:59 GMT+8 (lokal tid 00:00-23:59)",
  充值方式: "Indbetalingsmetode",
  银行汇款: "Bankoverførsel",
  "银行汇款请联系客服进行操作!":
    "Kontakt venligst kundeservice for at foretage bankoverførsel!",
  提款方式: "Udbetalingsmetode",
  "银行提款请联系客服进行操作!":
    "Kontakt venligst kundeservice for at foretage bankudbetaling!",
  资金明细: "Finansielle detaljer",
  提现记录: "Udbetalingshistorik",
  拒绝: "Afvist",
  通过: "Godkendt",
  拒绝原因: "Årsag til afvisning",

  消息公告: "Meddelelser",
  订单: "Ordrer",
  个人中心: "Personligt center",
  "未到期赎回需支付一定的违约金!":
    "Ved førtidig indløsning skal der betales en bod.",

  请输入区号: "Indtast venligst områdenummer",
  "请选择国家/地区": "Vælg venligst land/område",

  今日开盘: "Dagens åbning",
  昨日收盘: "Gårsdagens lukning",

  实名认证即送: "Få det straks efter identitetsbekræftelse",
  立即认证: "Bekræft nu",
  新用户礼包: "Velkomstpakke til nye brugere",
  完成新人任务领取: "Gennemfør opgaverne for nye brugere for at modtage",
  认证: "Bekræftelse",
  时间周期: "Tidsperiode",
  支付金额: "Betalingsbeløb",
  已平仓: "Lukket",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX velkomstpakke til nye brugere: Hver bruger kan højst modtage",
  我已经阅读并同意: "Jeg har læst og accepterer",
  隐私政策: "Privatlivspolitik",

  放弃奖励离开: "Opgiv belønningen og forlad",
  继续注册: "Fortsæt registreringen",
  分钟: "Minutter",

  "请先勾选隐私政策!": "Læs venligst privatlivspolitikken først!",
  添加其他到自选: "Tilføj andre til overvågningslisten",
  充值最高可得: "Fyld op, og få op til 30.000 $.",

  请输入格式正确的手机号: "Indtast venligst et gyldigt mobilnummer.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 丹麦



// WEBPACK FOOTER //
// ./src/lang/dm.js